angular.module('impactx.timeline').directive('ixTableTimeline', function() {
    return {
        scope: {
            data: '='
        },
        restrict: 'E',
        controller: 'TableTimelineCtrl',
        controllerAs: 'tableTimelineCtrl',
        templateUrl: 'modules/timeline/templates/tabletimeline.tmpl.html'
    }
});